module.exports = "img/flags/VN.ea2caec.png";